const Container = () => {
  return {
    MuiContainer: {
      styleOverrides: {
        root: {},
      },
    },
  }
}

export default Container
